export default "__VITE_ASSET__1dcfb442__"